import React, { useEffect } from "react";
// Material Dashboard 2 PRO React examples
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import { useMsal } from "@azure/msal-react";
import { useNativeAuth } from "context/NativeAuthContext";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import { useNativeAuthForSignIn, protectedResources, siteData } from "authConfig";

function Logout() {
  const { instance } = useMsal();
  const { clearTokens, getAccessToken } = useNativeAuth();
  const { execute } = useFetchWithMsal({ scopes: [siteData?.apiScopes] });

  const logout = async () => {
    // Close the user's activity session before tokens are cleared (the beacon needs a valid
    // token). Best-effort and time-boxed so a slow/unreachable API never blocks sign-out.
    try {
      const base = protectedResources?.apiTodoList?.endpoint || "";
      if (base) {
        await Promise.race([
          execute("POST", `${base}/activity/logout`, {}),
          new Promise((resolve) => {
            setTimeout(resolve, 1500);
          }),
        ]);
      }
    } catch {
      /* never block logout on the beacon */
    }

    const hadNativeTokens = !!getAccessToken?.();
    clearTokens();
    if (useNativeAuthForSignIn && hadNativeTokens) {
      window.location.href = "/";
      return;
    }
    const accounts = instance.getAllAccounts?.() || [];
    if (accounts.length > 0) {
      await instance.logoutRedirect();
    } else {
      window.location.href = "/";
    }
  };
  useEffect(() => {
    logout();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="jumbotron">
        <h1>Logging out .....</h1>
        <p className="lead">Thanks for using PAGERisk!</p>
        {/*  {   <p>
        <button className="btn btn-lg btn-warning" onClick={() => KcUserService.doLogin()}>Login</button>
      </p> } */}
      </div>
    </DashboardLayout>
  );
}

export default Logout;
